import WatchList from "./WatchList";

const HasWatchList = () => {
  return <WatchList />;
};

export default HasWatchList;
